import { render } from "./tw-grid-view-ag.vue?vue&type=template&id=227062b6"
import script from "./tw-grid-view-ag.vue?vue&type=script&lang=js"
export * from "./tw-grid-view-ag.vue?vue&type=script&lang=js"
script.render = render

export default script